






































import { defineComponent, ref } from '@vue/composition-api';
import { useGroups } from '@/store/modules/group';
import { useAllResources } from '@/store/modules/resources';
import GroupsTable from '@/views/super-admin/GroupsTable.vue';
import StratifyButton from '../stratify/StratifyButton.vue';
import FieldsTable from './FieldsTable.vue';
import StratificationJobsTable from './StratificationJobsTable.vue';
import StratificationsTable from './StratificationsTable.vue';
import UsersTable from './UsersTable.vue';

export default defineComponent({
	components: {
		UsersTable,
		FieldsTable,
		StratificationsTable,
		GroupsTable,
		StratificationJobsTable,
		StratifyButton,
	},
	setup(_, { root }) {
		const tabItems = ['Fields', 'Users', 'Stratifications', 'Groups', 'Stratification Jobs'];
		const tab = ref<string>(tabItems[0]);
		const {
			isLoaded: areResourcesLoaded,
			isLoading: areResourcesLoading,
			fields,
			stratifications,
			hasError: hasResourcesError,
		} = useAllResources(root.$store);

		const { isLoaded: areGroupsLoaded, isLoading: areGroupsLoading, hasError: hasGroupsError, groups } = useGroups(
			root.$store
		);

		return {
			areResourcesLoaded,
			areResourcesLoading,
			hasResourcesError,
			areGroupsLoaded,
			areGroupsLoading,
			hasGroupsError,
			tabItems,
			tab,
			fields,
			stratifications,
			groups,
		};
	},
});
